import { Fragment, useContext } from 'react'
import { IproviderFundAcc, ProviderFundAccount } from './FundAccoutingForm';
import { useFieldArray } from 'react-hook-form';
import _ from "lodash";
import { parseFloatCheckValue } from '../Ticket/fnTickit';
import { Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { BtnAdd, BtnDeleteTable } from 'components/Button/ButtonAll';
import { I18n } from 'utilities/utilities';
import { I18NextNs } from 'enum/enum';
import InputReactNumber from '../InputReactNumber';
import { ItemFundAcc } from './interfaceFundAcc';
import { TextBoxItem } from 'components/Input/TextBox';

export const TableMoreDetail = () => {

    const {
        isView,
        DialogFn,
        form,
        findValue,
        findMaxID,
        setEqualBalance
    } = useContext<IproviderFundAcc>(ProviderFundAccount);


    const { control, watch } = form;
    const { fields } = useFieldArray({
        control,
        name: "lstMoreDetail"
    });

    const watchFieldArray = watch("lstMoreDetail");
    const controlledFields = fields.map((field, index) => {
        return {
            ...field,
            ...watchFieldArray[index]
        };
    });

    const handleAdd = (dataRow: ItemFundAcc, nParentID: number | null) => {
        let lstMoreDetail = watch("lstMoreDetail");
        let deepCopy = _.cloneDeep(lstMoreDetail) as ItemFundAcc[];
        let nOrderMax = findMaxID(deepCopy);
        // Add In Sub Level
        let rowEdit: ItemFundAcc = findValue(deepCopy, "lstSubLevel", "nOrder", dataRow.nOrder);
        if (rowEdit) {
            let objAdd = {
                nID: null,
                nOrder: nOrderMax,
                sName: null,
                isCanAdd: true,
                isCanDelete: true,
                isDelete: false,
                isDisable: false,
                sTotal: null,
                lstSubLevel: [],
            } as ItemFundAcc

            if (!nParentID) {
                rowEdit.lstSubLevel.splice(0, 0, objAdd);
                form.setValue("lstMoreDetail", deepCopy);
                form.reset({
                    ...form.watch(),
                    lstMoreDetail : deepCopy
                });
                return;
            }

            //Find Index on handle
            let rowParent: ItemFundAcc = findValue(deepCopy, "lstSubLevel", "nOrder", nParentID);
            if (rowParent) {
                let nIndex = rowParent.lstSubLevel.findIndex(f => f.nOrder === dataRow.nOrder);
                if (nIndex > -1) {
                    rowParent.lstSubLevel.splice(nIndex + 1, 0, objAdd);
                }
            }
            form.setValue("lstMoreDetail", deepCopy);
            form.reset({
                ...form.watch(),
                lstMoreDetail : deepCopy
            });
        }
    }

    const calculateMoreDetail = (value: any, nParentID: number | null) => {
        // if (!value) {
        //     return;
        // }
        let lstMoreDetail = _.cloneDeep(watch("lstMoreDetail")) as ItemFundAcc[];

        if (nParentID) {
            lstMoreDetail.forEach((element: ItemFundAcc, index: number) => {
                if (element.nOrder === nParentID && element.lstSubLevel != null && element.lstSubLevel.length !== 0) {
                    let sum = _.sumBy(element.lstSubLevel, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
                    element.sTotal = sum + "";
                    form.setValue(`lstMoreDetail.${index}.sTotal`, sum + "")
                }
            });
        }

        let sumMoreDetail = _.sumBy(lstMoreDetail, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
        sumMoreDetail = Number(sumMoreDetail.toFixed(2));
        form.setValue("sTotalMoreDetail", sumMoreDetail + "")
        let nBalance  = parseFloatCheckValue(form.getValues("sBalance")) ?? 0;
        setEqualBalance(nBalance === sumMoreDetail)

        
    }

    const handleDelete = (dataRow: ItemFundAcc) => {

        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            let lstMoreDetail = watch("lstMoreDetail");
            let deepCopy = _.cloneDeep(lstMoreDetail) as ItemFundAcc[];
            let dtDelete: ItemFundAcc = findValue(deepCopy, "lstSubLevel", "nOrder", dataRow.nOrder);
            dtDelete.isDelete = true;
            const cleanIsDeleteInArray = removeDeletedItems(deepCopy);
            cleanIsDeleteInArray.forEach((element: ItemFundAcc, index: number) => {
                if (element.lstSubLevel != null && element.lstSubLevel.length !== 0) {
                    let sum = _.sumBy(element.lstSubLevel, (o: ItemFundAcc) => { return parseFloatCheckValue(o.sTotal); });
                    element.sTotal = sum + "";
                    form.setValue(`lstMoreDetail.${index}.sTotal`, sum + "")
                }
            });
            let sumMoreDetail = _.sumBy(cleanIsDeleteInArray, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
            form.setValue("sTotalMoreDetail", sumMoreDetail + "")
            form.setValue("lstMoreDetail", cleanIsDeleteInArray);
            DialogFn.CloseSubmit();
        });
    }

    const removeDeletedItems = (arr: ItemFundAcc[]) => {
        return arr.filter(item => !item.isDelete).map(item => {
            if (item.lstSubLevel && item.lstSubLevel.length > 0) {
                item.lstSubLevel = removeDeletedItems(item.lstSubLevel);
            }
            return item;
        });
    }


    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Divider textAlign="left" className="font-weight-500">รายละเอียดเพิ่มเติม</Divider>
            </Grid>
            <Grid item xs={12}>
                {/* Table */}
                <TableContainer id='table-fundacc' component={Paper}>
                    <Table >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" padding='none' style={{ minWidth: '60px', width: '60px' }}>ลำดับที่</TableCell>
                                <TableCell component="th" padding='none' >รายการ</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '200px', width: '200px' }}>จำนวนเงิน (บาท)</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '120px', width: '120px' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                controlledFields.map((row, index) => {
                                    const fieldName = `lstMoreDetail.${index}`;
                                    let isHasSubLevel = row.lstSubLevel != null && row.lstSubLevel.length > 0;
                                    return (
                                        <Fragment key={`${fieldName}.sID`}>
                                            <TableRow key={`${fieldName}.sID`} sx={{ backgroundColor: "#f2f2f2" }}>
                                                <TableCell align="center" >{index + 1}</TableCell>
                                                <TableCell align="left">
                                                    {row.sName}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <InputReactNumber
                                                        id={`${fieldName}.sTotal`}
                                                        name={`${fieldName}.sTotal`}
                                                        defaultValue={row.sTotal}
                                                        maxLength={16}
                                                        required={false}
                                                        valueType='string'
                                                        maxDigits={2}
                                                        IsCanMinus={false}
                                                        IsShowMessageError={false}
                                                        disabled={isHasSubLevel|| isView}
                                                        onChange={(value) => {
                                                            calculateMoreDetail(value, null)
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.isCanAdd && !isView && <BtnAdd id={`btnAdd${index}`} IsCircleWithOutText onClick={() => { handleAdd(row, null) }} />}
                                                    &nbsp;
                                                    {row.isCanDelete && !isView && <BtnDeleteTable id={`btnDelete${index}`} IsCircleWithOutText onClick={() => { handleDelete(row); }} />}
                                                </TableCell>
                                            </TableRow>
                                            {
                                                isHasSubLevel ?
                                                    <>
                                                        {
                                                            row.lstSubLevel.map((subRow, subIndex) => {
                                                                const subFieldName = `lstMoreDetail.${index}.lstSubLevel.${subIndex}`;
                                                                return (
                                                                    <TableRow key={`${subFieldName}.sID`}>
                                                                        <TableCell align="center" ></TableCell>
                                                                        <TableCell align="left" sx={{ paddingLeft: '40px !important' }}>
                                                                            {
                                                                                subRow.isCanAdd ?
                                                                                    <TextBoxItem
                                                                                        id={`${subFieldName}.sName`}
                                                                                        name={`${subFieldName}.sName`}
                                                                                        label=""
                                                                                        required={true}
                                                                                        maxLength={250}
                                                                                        disabled={isView}
                                                                                        IsShowMessageError={false}
                                                                                    />
                                                                                    :
                                                                                    subRow.sName
                                                                            }
                                                                        </TableCell>
                                                                        <TableCell align="right">
                                                                            <InputReactNumber
                                                                                id={`${subFieldName}.sTotal`}
                                                                                name={`${subFieldName}.sTotal`}
                                                                                defaultValue={subRow.sTotal}
                                                                                maxLength={16}
                                                                                valueType='string'
                                                                                required={false}
                                                                                maxDigits={2}
                                                                                disabled={isView}
                                                                                IsCanMinus={false}
                                                                                IsShowMessageError={false}
                                                                                onChange={(value) => {
                                                                                    calculateMoreDetail(value, row.nOrder)
                                                                                }}

                                                                            />
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            {subRow.isCanAdd && !isView && <BtnAdd id={`btnAdd${index}`} IsCircleWithOutText onClick={() => { handleAdd(subRow, row.nOrder) }} />}
                                                                            &nbsp;
                                                                            {subRow.isCanDelete && !isView && <BtnDeleteTable id={`btnDelete${index}`} IsCircleWithOutText onClick={() => { handleDelete(subRow); }} />}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        }
                                                    </> : null
                                            }
                                        </Fragment>

                                    )
                                })
                            }
                            {
                                controlledFields.length === 0 ?
                                    <TableRow >
                                        <TableCell align="center" colSpan={4}>ไม่พบข้อมูล</TableCell>
                                    </TableRow>
                                    :
                                    null
                            }
                            <TableRow sx={{ backgroundColor: "#e8be2a" }}>
                                <TableCell align="center" component="td" ></TableCell>
                                <TableCell align="center" component="td">รวม</TableCell>
                                <TableCell component="td" className='text-right'>
                                    <InputReactNumber
                                        id={`sTotalMoreDetail`}
                                        name={`sTotalMoreDetail`}
                                        valueType='string'
                                        required={false}
                                        maxDigits={2}
                                        IsCanMinus={false}
                                        IsShowMessageError={false}
                                        disabled
                                    />
                                </TableCell>
                                <TableCell align="center" component="td" ></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}
